var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5195 6562 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(5190 6542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    className: "cls-1",
    d: "M33.5,71H6.5a1.5,1.5,0,0,0,0,3h27a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(0 -34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    className: "cls-1",
    d: "M33.5,45H6.5a1.5,1.5,0,0,0,0,3h27a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(0 -16.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    className: "cls-1",
    d: "M33.5,20H6.5a1.5,1.5,0,0,0,0,3h27a1.5,1.5,0,0,0,0-3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5883cd925564b7073d157507301a0b7d.svg";
export { ForwardRef as ReactComponent };